import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, IconButton, Grid, Typography, Box, CardActionArea
} from '@mui/material';

// We map your sectionColorMap keys to specific icons
const CATEGORIES = [
    { id: 'Meals', icon: 'icon-fork-knife2', color: '#e8f2ed', iconColor: '#2e7d32' },
    { id: 'Activities', icon: 'icon-list-heart', color: '#cbe0f7', iconColor: '#1976d2' },
    { id: 'Lodging', icon: 'icon-bed', color: '#fef4ec', iconColor: '#ed6c02' },
    { id: 'Flights', icon: 'icon-airplane', color: '#fcf9dd', iconColor: '#fbc02d' },
    { id: 'Transportation', icon: 'icon-car', color: '#D6F5E4', iconColor: '#00897b' },
    { id: 'Shopping', icon: 'icon-bag', color: '#B2D4F0', iconColor: '#0288d1' },
    { id: 'Supplies', icon: 'icon-checklist2', color: '#FEE5D4', iconColor: '#d32f2f' },
    { id: 'Incidentals', icon: 'icon-basket', color: '#FAF3CC', iconColor: '#f9a825' },
    { id: 'General', icon: 'icon-helm', color: '#EDE7F6', iconColor: '#673ab7' },
];

function ReceiptDialogEditCategory({ isOpen, onClose, receipt, onSave }) {
    const [selectedCategory, setSelectedCategory] = useState("");

    useEffect(() => {
        if (isOpen && receipt) {
            setSelectedCategory(receipt.section || "");
        }
    }, [isOpen, receipt]);

    const handleSelect = (categoryId) => {
        setSelectedCategory(categoryId);
    };

    const handleSave = () => {
        onSave(receipt.id, { section: selectedCategory });
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            PaperProps={{
                sx: { borderRadius: '20px', padding: '8px', minWidth: 450 }
            }}
        >
            {/* Consistent Creative Header */}
            <DialogTitle sx={{
                p: 3,
                textAlign: 'center',
                background: 'linear-gradient(135deg, #151269 0%, #352fcc 100%)',
                color: 'white',
                borderRadius: '15px 15px 5px 5px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '1px' }}>
                    SELECT CATEGORY
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                    Classify this expense for better reporting
                </Typography>
            </DialogTitle>

            <IconButton onClick={onClose} sx={{ position: 'absolute', right: 16, top: 16, color: 'white' }}>
                <i className="icon-cross" style={{ fontSize: '18px' }} />
            </IconButton>

            <DialogContent sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                    {CATEGORIES.map((cat) => (
                        <Grid item xs={4} key={cat.id}>
                            <Box
                                onClick={() => handleSelect(cat.id)}
                                sx={{
                                    borderRadius: '16px',
                                    border: '2px solid',
                                    borderColor: selectedCategory === cat.id ? '#151269' : '#f0f0f0',
                                    bgcolor: selectedCategory === cat.id ? 'rgba(21, 18, 105, 0.04)' : 'transparent',
                                    transition: 'all 0.2s ease-in-out',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#352fcc',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                    }
                                }}
                            >
                                <Box sx={{ p: 2, textAlign: 'center' }}>
                                    <i className={cat.icon} style={{
                                        fontSize: '28px',
                                        color: selectedCategory === cat.id ? '#151269' : '#666'
                                    }} />
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mt: 1,
                                            fontWeight: 600,
                                            color: selectedCategory === cat.id ? '#151269' : '#666'
                                        }}
                                    >
                                        {cat.id}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
                <Button onClick={onClose} sx={{ color: '#151269', fontWeight: 600 }}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    disabled={!selectedCategory}
                    sx={{
                        borderRadius: '10px',
                        px: 4,
                        bgcolor: '#151269',
                        '&:hover': { bgcolor: '#352fcc' }
                    }}
                >
                    Confirm Category
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ReceiptDialogEditCategory;